// extracted by mini-css-extract-plugin
export default {"loadingComponent":"ZHNyyy"};